import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowStatCollapse = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 11,
	viewBox: "0 0 12 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.75 10.7812C0.335815 10.7812 0 10.4454 0 10.0312C0 9.61707 0.335815 9.28125 0.75 9.28125H11.25C11.6642 9.28125 12 9.61707 12 10.0312C12 10.4454 11.6642 10.7812 11.25 10.7812H0.75ZM11.3066 5.6875C11.5352 5.45898 11.5352 5.05273 11.2812 4.82422L6.40625 0.152344C6.2793 0.0507812 6.12695 0 5.97461 0C5.84766 0 5.69531 0.0507812 5.56836 0.152344L0.693359 4.82422C0.439453 5.05273 0.439453 5.45898 0.667969 5.6875C0.896484 5.94141 1.30273 5.94141 1.53125 5.71289L5.97461 1.44727L10.4434 5.71289C10.6719 5.94141 11.0781 5.94141 11.3066 5.6875Z",
		fill: "#78909C"
	})]
});
const ForwardRef = forwardRef(SvgArrowStatCollapse);
export { ForwardRef as ReactComponent };
